<template>
  <b-container id="request-details">
    <b-spinner v-show="!isLoaded" label="Loading..." />
    <b-card
      v-show="isLoaded"
      header-text-variant="white"
      :header-bg-variant="isActivated ? 'success' : 'warning'"
      :header="user.usrFirstName + ' ' + user.usrLastName"
    >
      <b-card-body class="text-left">
        <p><b>E-Mail:</b> {{ user.usrEmail }}</p>
        <p><b>Dienstleistungen:</b></p>
        <b-list-group>
          <b-list-group-item
            v-for="service in user.services"
            :key="service.serId"
            class="text-left"
          >
            {{ $t(service.serTranslationId, "de") }}
          </b-list-group-item>
        </b-list-group>
        <b-row>
          <b-col>
            <b-button
              @click="activate"
              :disabled="isActivated || isActivating"
              variant="success"
              class="w-100"
            >
              <b-spinner v-show="isActivating" small />
              Aktivieren
            </b-button>
          </b-col>
          <b-col>
            <b-button
              @click="deactivate"
              :disabled="!isActivated || isDeactivating"
              variant="warning"
              class="w-100"
            >
              <b-spinner v-show="isDeactivating" small />
              Deaktivieren
            </b-button>
          </b-col>
          <b-col>
            <b-button
              @click="showRemoveRequestModal"
              variant="danger"
              class="w-100"
            >
              Entfernen
            </b-button>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-alert
              dismissible
              @dismissed="removed = false"
              variant="success"
              :show="removed"
            >
              {{ message }}
            </b-alert>
            <b-alert
              dismissible
              @dismissed="error = ''"
              variant="danger"
              :show="error"
            >
              {{ errorMessage }}
            </b-alert>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <remove-request-modal ref="modal-remove-request" :okFunction="remove" />
  </b-container>
</template>

<script>
import RemoveRequestModal from "@/components/modals/RemoveRequestModal.vue";

export default {
  name: "UserDetails",
  components: { RemoveRequestModal },
  data() {
    return {
      user: {},
      isLoaded: false,
      isActivating: false,
      isDeactivating: false,
      removed: false,
      error: false,
      message: "",
      errorMessage: ""
    };
  },
  created() {
    this.$http
      .get("/user/" + this.$route.params.id)
      .then(this.updateDetails)
      .finally(() => (this.isLoaded = true));
  },
  methods: {
    activate() {
      this.isActivating = true;
      this.changeActivationState("1");
    },
    deactivate() {
      this.isDeactivating = true;
      this.changeActivationState("0");
    },
    showRemoveRequestModal() {
      this.$refs["modal-remove-request"].show();
    },
    remove() {
      const data = new FormData();
      data.append("userId", this.$route.params.id);
      this.$http
        .post("user/remove", data)
        .then(response => {
          this.message = response.data.message;
          this.removed = true;
          this.$router.push("/users");
        })
        .catch(error => {
          this.error = true;
          this.errorMessage = error.response.data.message;
        })
        .finally(() => (this.isLoading = false));
    },
    changeActivationState(state) {
      let form = new FormData();
      form.append("isActivated", state);
      this.$http
        .post("/user/activate/" + this.user.usrId, form)
        .then(this.updateDetails)
        .finally(() => {
          this.isDeactivating = false;
          this.isActivating = false;
        });
    },
    updateDetails(response) {
      this.user = response.data.data;
    }
  },
  computed: {
    isActivated() {
      return Boolean(Number(this.user.usrIsActivated));
    }
  }
};
</script>

<style scoped>
.list-group {
  margin-bottom: 15px;
}
</style>
